import React from 'react';
import MetricsCard from '../Shared/MetricsCard';
import { useLastMetrics } from '../../hooks/useLastMetrics';
import { findSensorValue } from '../../utils/sensorHelpers';
import styles from './Analytics.module.css';
import { formatMinutes } from '../../utils/dateUtils';
import { useTranslation } from 'react-i18next';

export default function KeyDataPoints({ systemId }) {
  const { t } = useTranslation();
  const { lastMetrics, timeSinceLastReading } = useLastMetrics(systemId);
  return (
    <div className={styles.keyDataPointsContainer}>
      <MetricsCard
        value={formatMinutes(timeSinceLastReading, t('h'))}
        subtext={'Time since last data'}
      />
      <MetricsCard
        value={findSensorValue(lastMetrics, 'SOC', '%')}
        subtext={'SOC'}
      />
      <MetricsCard
        value={findSensorValue(lastMetrics, 'SystemVoltage', 'V')}
        subtext={'Voltage'}
      />
      <MetricsCard
        value={findSensorValue(lastMetrics, 'Current', 'A')}
        subtext={'Current'}
      />
      <MetricsCard
        value={findSensorValue(lastMetrics, 'MaxCellVoltage', 'V')}
        subtext={'Max cell voltage'}
      />
      <MetricsCard
        value={findSensorValue(lastMetrics, 'MinCellVoltage', 'V')}
        subtext={'Min cell voltage'}
      />
    </div>
  );
}
